import { render } from "./ReportNewActions.vue?vue&type=template&id=1d1a3889"
import script from "./ReportNewActions.vue?vue&type=script&lang=js"
export * from "./ReportNewActions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportNewActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d1a3889"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d1a3889', __exports__)) {
    console.log('reload')
    api.reload('1d1a3889', __exports__)
  }
  
  module.hot.accept("./ReportNewActions.vue?vue&type=template&id=1d1a3889", () => {
    console.log('re-render')
    api.rerender('1d1a3889', render)
  })

}


export default __exports__